import pixels from './module/wrapper-standard';

window.pixels = pixels;
